/**
 * GeoPST Map Security Gatekeeper
 * Include this script at the very top of the <head> in map.html
 */

(function () {
    // Hide the body to prevent any FOUC or UI leakage before token is verified
    document.documentElement.style.visibility = 'hidden';

    // 1. Public Page Whitelist (Public access allowed without token)
    const publicPages = [
        '/map-login.html',
        '/map-register.html',
        '/map-forgot-password.html',
        '/map-reset-password.html'
    ];

    const isPublicPage = publicPages.some(page => window.location.pathname.endsWith(page));

    // 2. Immediate Token Check
    const token = localStorage.getItem('map_token') || sessionStorage.getItem('map_token');

    if (isPublicPage) {
        // Safe to reveal public pages immediately
        document.documentElement.style.visibility = '';
        if (token) {
            // Optional: If already logged in and visiting login/register, redirect to map
            if (window.location.pathname.endsWith('/map-login.html') || window.location.pathname.endsWith('/map-register.html')) {
                window.location.replace('/map.html');
            }
        }
        // Exit security script for public pages
        return;
    }

    if (!token) {
        console.warn('Map Security: No token found. Redirecting to login.');
        window.location.replace('/map-login.html'); // replace() prevents back-button looping
        return;
    }

    // 2. Asynchronous Token Verification with Backend
    fetch('/api/mapAuth/verify', {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    })
        .then(async (response) => {
            if (!response.ok) {
                console.warn('Map Security: Token invalid or expired. Logging out.');
                window.logout(true);
                return;
            }

            const data = await response.json();
            if (data.valid) {
                // Token is good, reveal the document
                document.documentElement.style.visibility = '';
            } else {
                window.logout(true);
            }
        })
        .catch((error) => {
            console.error('Map Security Verify Error:', error);
            // FAIL-CLOSED: Do NOT reveal the document on network error.
            // Instead, show a critical error overlay or redirect to login.
            document.write(`
                <div style="height:100vh; display:flex; flex-direction:column; align-items:center; justify-content:center; font-family:sans-serif; background:#f8fafc; color:#1e293b; text-align:center; padding:20px; direction:rtl;">
                    <div style="font-size:48px; margin-bottom:20px;">⚠️</div>
                    <h1 style="font-size:24px; margin-bottom:10px;">عذراً، فشل التحقق من الجلسة</h1>
                    <p style="font-size:16px; color:#64748b; max-width:400px; margin-bottom:30px;">حدث خطأ أثناء محاولة الاتصال بخوادم GeoPST. يرجى التحقق من اتصالك بالإنترنت والمحاولة مجدداً.</p>
                    <button onclick="window.location.reload()" style="padding:12px 24px; background:#c41e3a; color:white; border:none; border-radius:8px; cursor:pointer; font-weight:600; font-size:16px;">إعادة المحاولة</button>
                    <a href="/map-login.html" style="margin-top:20px; color:#64748b; text-decoration:none; font-size:14px;">العودة لتسجيل الدخول</a>
                </div>
            `);
        });

    // 3. Fetch Interceptor / Wrapper (secureFetch)
    window.secureFetch = async function (url, options = {}) {
        // Ensure headers object exists safely
        const headers = options.headers || {};

        // Always retrieve a fresh token in case things updated
        const currentToken = localStorage.getItem('map_token') || sessionStorage.getItem('map_token');

        // Inject Bearer token
        if (currentToken) {
            headers['Authorization'] = `Bearer ${currentToken}`;
        }

        const fetchOptions = {
            ...options,
            headers: {
                ...headers,
                // Ensure json content type if body is passed implicitly
                ...(options.body && !(headers['Content-Type'] || headers['content-type']) ? { 'Content-Type': 'application/json' } : {})
            }
        };

        try {
            const response = await fetch(url, fetchOptions);

            // 4. Global 401 Handler
            if (response.status === 401) {
                console.warn('Map Security: 401 Unauthorized detected. Session expired.');
                window.logout(true); // Handle kicking user safely
            }

            return response;
        } catch (error) {
            console.error('SecureFetch Network Error:', error);
            throw error; // Bubble up for downstream catches
        }
    };

    // 5. Global Logout Function
    // Standardized Global Logout logic
    window.logout = async function (sessionExpired = false) {
        const token = localStorage.getItem('map_token') || sessionStorage.getItem('map_token');

        if (token) {
            try {
                // Inform backend to delete the session
                await fetch('/api/mapAuth/logout', {
                    method: 'POST',
                    headers: { 'Authorization': `Bearer ${token}` }
                });
            } catch (err) {
                console.warn('[Logout] Server-side invalidation failed, but proceeding with local cleanup.');
            }
        }

        // Local cleanup
        localStorage.removeItem('map_token');
        sessionStorage.removeItem('map_token');

        // Redirect with optional error parameter
        const redirectUrl = sessionExpired ? '/map-login.html?error=session_expired' : '/map-login.html';
        window.location.replace(redirectUrl);
    };

    // 6. Heartbeat — Update last_seen every 5 minutes (silent, non-blocking)
    // This ensures users browsing the map without WFS requests are tracked as active
    let heartbeatInterval = null;
    function startHeartbeat() {
        // Send initial heartbeat immediately
        sendHeartbeat();
        // Then every 5 minutes
        heartbeatInterval = setInterval(sendHeartbeat, 5 * 60 * 1000);
    }

    function sendHeartbeat() {
        const tkn = localStorage.getItem('map_token') || sessionStorage.getItem('map_token');
        if (!tkn) return;
        fetch('/api/mapAuth/heartbeat', {
            method: 'POST',
            headers: { 'Authorization': `Bearer ${tkn}` }
        }).catch(() => { /* Silent — don't disrupt user experience */ });
    }

    // Start heartbeat after token is verified
    startHeartbeat();

    // Cleanup on page unload
    window.addEventListener('beforeunload', () => {
        if (heartbeatInterval) clearInterval(heartbeatInterval);
    });
})();
